import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles"
/**
 * 
 *  const RageItalic =  {
      fontFamily: "RageItalic",
      src: `url("./fonts/RAGE.eot"), url("./fonts/RAGE.eot?#iefix") format("embedded-opentype"),
        url("./fonts/RAGE.otf") format("opentype"),
        url("./fonts/RAGE.ttf") format("truetype"),
        url("./fonts/RAGE.woff2") format("woff2"),
        url("./fonts/RAGE.woff") format("woff")`,
      fontWeight: "normal",
      fontStyle: "normal",
    }

  let theme = createMuiTheme({
    ...
    overrides: {
      MuiCssBaseline: {-
        "@global": {
          "@font-face": [RageItalic],
        },
      },
    },
    ...
*/

let theme = createMuiTheme({
  palette: {
    primary: {
      main: "#000",
    },
    secondary: {
      main: "#DEDE32",
    },
    background: {
      default: "#eee",
      paper: "#FFF",
    },
    text: {
      primary: "#000",
      secondary: "#FFF",
    },
  },
  typography: {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
    fontSize: 12,
    h1: {
      lineHeight: 1.2,
      fontSize: 19,
      fontWeight: 900,
    },
  },
})
const options = { factor: 2 }
theme = responsiveFontSizes(theme, options)

export default theme

